require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-lindy-levinson.json") })
        }
      }, "path---blog-author-lindy-levinson");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-lindy-levinson!./.cache/json/blog-author-lindy-levinson.json
// module id = 672
// module chunks = 231608221292675